import {
  Text,
  IconReceiptBill,
  IconCircleX,
  GreyGrey70,
  Primary13Regular,
  Primary13SemiBold
} from '@sequencehq/core-components'

import { toMoney } from '@sequencehq/utils'

import { InvoicePreviewCard, NodeTimeline } from 'Automations/components'
import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useInvoiceData } from '../../hooks/useInvoiceData'
import { InvoiceActions } from './InvoiceActions'

export const InvoiceEmailFailedPreview = (props: { taskId: string }) => {
  const { manualTask } = useManualTask({ taskId: props.taskId })
  const input = manualTask?.input as TaskInput | undefined
  const { invoice, customer, invoiceDetails } = useInvoiceData(input?.invoiceId)

  const hasInvoiceData = invoice && customer && invoiceDetails

  return (
    <>
      <NodeTimeline.Item icon={<IconReceiptBill />} showStem>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label="Invoice created"
            timestamp={invoice?.createdAt}
          />
        </NodeTimeline.Title>

        {hasInvoiceData && (
          <InvoicePreviewCard
            invoice={invoice}
            customer={customer}
            invoiceDetails={invoiceDetails}
            startCollapsed
          />
        )}
      </NodeTimeline.Item>

      <NodeTimeline.Item icon={<IconCircleX />} showStem={false} highlightIcon>
        <NodeTimeline.Title>
          <NodeTimeline.UserAction
            label={
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                Invoice failed to send
              </Text>
            }
            timestamp={manualTask?.createdAt}
          />
        </NodeTimeline.Title>

        {hasInvoiceData && (
          <>
            <Text {...Primary13Regular} color={GreyGrey70} marginBottom="16px">
              Invoice{' '}
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {invoice.invoiceNumber}
              </Text>{' '}
              for{' '}
              <Text as="span" {...Primary13SemiBold} color={GreyGrey70}>
                {customer.legalName}
              </Text>{' '}
              (
              {toMoney({
                value: invoice.grossTotal,
                currency: invoice.currency
              })}
              ) could not be delivered automatically. Download the PDF and send
              it manually.
            </Text>

            <InvoicePreviewCard
              invoice={invoice}
              customer={customer}
              invoiceDetails={invoiceDetails}
              action={
                <InvoiceActions
                  invoiceId={invoice.id}
                  invoiceNumber={invoice.invoiceNumber}
                  invoiceStatus={invoice.status}
                />
              }
            />
          </>
        )}
      </NodeTimeline.Item>
    </>
  )
}
